<script>
  import { onMount } from "svelte";

  export let title = "ALADV content";

  const frontendRemoteUrl = process.env.SVELTE_APP_FE_REMOTE_URL || "";
  const adminRemoteUrl = process.env.SVELTE_APP_REMOTE_URL || "";

  function remoteEntry(url) {
    if (!url) return "";
    return `${url.replace(/\/(?:remoteEntry\.js)?$/, "")}/remoteEntry.js`;
  }

  function remoteScope(url) {
    try {
      return new URL(url, window.location.href).hostname.split(".")[0].replace(/-/g, "");
    } catch {
      return "";
    }
  }

  function previewUrlFromRemote() {
    try {
      const remote = new URL(frontendRemoteUrl);
      const [remoteName, ...domain] = remote.hostname.split(".");
      const namespace = remoteName.replace(/-aladv-grasfe-gruim$/, "");
      if (namespace === remoteName || domain.length === 0) return "";
      return `${remote.protocol}//${namespace}-strapi-preview.${domain.join(".")}`;
    } catch {
      return "";
    }
  }

  function previewBaseUrl() {
    if (typeof window === "undefined") return "";

    const [namespace, ...domain] = window.location.hostname.split(".");
    if (domain.length === 0) return previewUrlFromRemote();
    return `${window.location.protocol}//${namespace}-strapi-preview.${domain.join(".")}`;
  }

  function layoutSlugFromPath() {
    if (typeof window === "undefined") return "aws-products";
    return window.location.pathname.split("/").filter(Boolean).join("/") || "aws-products";
  }

  let layoutSlug = layoutSlugFromPath();
  let viewportGroup = "";
  let previewKey = 0;
  let iframe;
  let initialResizeDone = false;

  function previewOrigin() {
    try {
      return new URL(previewBaseUrl(), window.location.href).origin;
    } catch {
      return "";
    }
  }

  function sendAuthToken() {
    const targetOrigin = previewOrigin();
    if (!targetOrigin || !iframe?.contentWindow) return;
    iframe.contentWindow.postMessage(
      {
        type: "aladv-auth-token",
        token: localStorage.getItem("token"),
        entity: new URLSearchParams(window.location.search).get("entity") || "",
        adminRemote: {
          scope: remoteScope(adminRemoteUrl),
          remoteEntry: remoteEntry(adminRemoteUrl),
        },
      },
      targetOrigin,
    );
  }

  function handleIframeLoad() {
    sendAuthToken();
    if (initialResizeDone || !iframe) return;
    initialResizeDone = true;

    requestAnimationFrame(() => {
      if (!iframe) return;
      iframe.style.width = "calc(100% - 1px)";
      requestAnimationFrame(() => {
        if (iframe) iframe.style.width = "100%";
      });
    });
  }

  function getViewportGroup() {
    if (window.innerWidth < 640) return "mobile";
    if (window.innerWidth < 1024) return "tablet";
    return "desktop";
  }

  onMount(() => {
    viewportGroup = getViewportGroup();

    const updateLayout = () => {
      layoutSlug = layoutSlugFromPath();
    };
    const updateViewport = () => {
      const nextViewportGroup = getViewportGroup();
      if (nextViewportGroup !== viewportGroup) {
        viewportGroup = nextViewportGroup;
        previewKey += 1;
      }
    };
    const handlePreviewMessage = (event) => {
      if (event.origin !== previewOrigin() || event.source !== iframe?.contentWindow) return;
      if (event.data?.type === "aladv-auth-request") {
        sendAuthToken();
      } else if (event.data?.type === "aladv-admin-entity") {
        const url = new URL(window.location.href);
        if (event.data.entity) url.searchParams.set("entity", event.data.entity);
        else url.searchParams.delete("entity");
        history.replaceState({}, "", url);
      }
    };

    window.addEventListener("popstate", updateLayout);
    window.addEventListener("resize", updateViewport);
    window.addEventListener("message", handlePreviewMessage);
    return () => {
      window.removeEventListener("popstate", updateLayout);
      window.removeEventListener("resize", updateViewport);
      window.removeEventListener("message", handlePreviewMessage);
    };
  });

  $: baseUrl = previewBaseUrl();
  $: src = baseUrl && layoutSlug
    ? `${baseUrl}/${layoutSlug.split("/").map(encodeURIComponent).join("/")}`
    : baseUrl;
</script>

{#key previewKey}
  <iframe bind:this={iframe} {src} {title} loading="eager" allow="clipboard-read; clipboard-write" on:load={handleIframeLoad}></iframe>
{/key}

<style>
  iframe {
    display: block;
    width: 100%;
    min-height: 100vh;
    border: 0;
    background: #fff;
  }

</style>
